const SidebarData = [
  {
    label: "Menu",
    isMainMenu: true,
    isAllowedFor: ["distributor", "sub-distributor"],
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    isHasArrow: true,
    bgcolor: "bg-primary",
    isAllowedFor: ["distributor", "sub-distributor"],
  },
  {
    label: "Sub Distributor Management",
    icon: "mdi mdi-account-edit-outline",
    isHasArrow: true,
    url: "/sub-distributor",
    isAllowedFor: ["distributor"],
  },
  {
    label: "Capital Investment",
    icon: "mdi mdi-bank",
    isHasArrow: true,
    url: "/record-book",
    isAllowedFor: ["distributor", "sub-distributor"],
  },
  {
    label: "Deposit",
    icon: "mdi mdi-cash",
    isHasArrow: true,
    url: "/deposit",
    isAllowedFor: ["distributor", "sub-distributor"],
  },
  {
    label: "Expenses",
    icon: "mdi mdi-cash-minus",
    isHasArrow: true,
    url: "/expenses",
    isAllowedFor: ["distributor", "sub-distributor"],
  },
  {
    label: "Customer Management",
    icon: "mdi mdi-account-group",
    isHasArrow: true,
    url: "/customer",
    isAllowedFor: ["distributor", "sub-distributor"],
  },
];
export default SidebarData;
